import React from "react";
import {
  IconButton,
  TextField,
  Tooltip,
  InputAdornment
} from "@material-ui/core";
import { InfoOutlined } from "@material-ui/icons";

export default function TextFieldWithToolTip({
  labelHeading = "",
  keyValue = "",
  isRequired = false,
  disabled = false,
  toolTip = "",
  id = "",
  txtName = "",
  value = "",
  type = undefined,
  inProps = false,
  isForFilter = false,
  onChange = () => {},
  onKeyDown = () => {},
  addPrefix = null,
  boldLabel = false,
  setFocus = false,
  addTitle = false,
  requestedForRef= null
}) {
  return (
    requestedForRef === null ?
    <TextField
      autoComplete={"off"}
      fullWidth={!isForFilter}
      className={
        isForFilter ? "txt-Field-width" : setFocus && "input-text-size"
      }
      autoFocus={setFocus && true}
      InputLabelProps={{ style: { pointerEvents: "auto" } }}
      id={id}
      name={txtName}
      onChange={event =>
        keyValue ? onChange(keyValue, event.target.value) : onChange(event)}
      type={type && "number"}
      onFocus={e => e.currentTarget.select()}
      onKeyPress={event => {
        if (type == "number" && (event?.key === "-" || event?.key === "+")) {
          event.preventDefault();
        }
      }}
      onKeyDown={e => onKeyDown(e)}
      value={value}
      title={addTitle ? value : null}
      label={
        <div className={"labelWidth"}>
          {boldLabel ? (
            <span>
              {" "}
              <b>{labelHeading} </b>
            </span>
          ) : (
            <span> {labelHeading} </span>
          )}
          {isRequired && <span className={"requiredFldText"}>{" *"}</span>}
          {toolTip && (
            <>
              {addTitle ? (
                <Tooltip placement={"top-start"} title={toolTip}>
                  <IconButton
                    id={"iconBtn"}
                    size={"small"}
                    className={"tooltip-iconSize"}
                  >
                    <InfoOutlined fontSize={"inherit"} />
                  </IconButton>
                </Tooltip>
              ) : (
                <Tooltip title={toolTip}>
                  <IconButton
                    id={"iconBtn"}
                    size={"small"}
                    className={"tooltip-iconSize"}
                  >
                    <InfoOutlined fontSize={"inherit"} />
                  </IconButton>
                </Tooltip>
              )}
            </>
          )}
        </div>
      }
      disabled={disabled}
      InputProps={{
        startAdornment: addPrefix && (
          <InputAdornment position={"start"}>
            <b>
              <span className={"span-label"}>{"REQ - "}</span>
            </b>
          </InputAdornment>
        ),
        inputProps: { min: 1, maxLength: inProps && 250 }
      }}
    />
    :
    <TextField
      autoComplete={"off"}
      fullWidth={!isForFilter}
      className={
        isForFilter ? "txt-Field-width" : setFocus && "input-text-size"
      }
      autoFocus={setFocus && true}
      InputLabelProps={{ style: { pointerEvents: "auto" } }}
      id={id}
      name={txtName}
      onChange={event =>
        keyValue ? onChange(keyValue, event.target.value) : onChange(event)}
      type={type && "number"}
      onFocus={e => e.currentTarget.select()}
      onKeyPress={event => {
        if (type == "number" && (event?.key === "-" || event?.key === "+")) {
          event.preventDefault();
        }
      }}
      onKeyDown={e => onKeyDown(e)}
      value={value}
      title={addTitle ? value : null}
      label={
        <div className={"labelWidth"}>
          {boldLabel ? (
            <span>
              {" "}
              <b>{labelHeading} </b>
            </span>
          ) : (
            <span> {labelHeading} </span>
          )}
          {isRequired && <span className={"requiredFldText"}>{" *"}</span>}
          {toolTip && (
            <>
              {addTitle ? (
                <Tooltip placement={"top-start"} title={toolTip}>
                  <IconButton
                    id={"iconBtn"}
                    size={"small"}
                    className={"tooltip-iconSize"}
                  >
                    <InfoOutlined fontSize={"inherit"} />
                  </IconButton>
                </Tooltip>
              ) : (
                <Tooltip title={toolTip}>
                  <IconButton
                    id={"iconBtn"}
                    size={"small"}
                    className={"tooltip-iconSize"}
                  >
                    <InfoOutlined fontSize={"inherit"} />
                  </IconButton>
                </Tooltip>
              )}
            </>
          )}
        </div>
      }
      disabled={disabled}
      InputProps={{
        startAdornment: addPrefix && (
          <InputAdornment position={"start"}>
            <b>
              <span className={"span-label"}>{"REQ - "}</span>
            </b>
          </InputAdornment>
        ),
        inputProps: { min: 1, maxLength: inProps && 250 }
      }}
      ref={requestedForRef} // Attach the ref to the input element

    />
  );
}
